export enum CommonEvents {
  ERROR= 'error',
}
